import { render, staticRenderFns } from "./ByLeaderTab.vue?vue&type=template&id=eb06c798&scoped=true"
import script from "./ByLeaderTab.vue?vue&type=script&lang=ts"
export * from "./ByLeaderTab.vue?vue&type=script&lang=ts"
import style0 from "./ByLeaderTab.vue?vue&type=style&index=0&id=eb06c798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06c798",
  null
  
)

export default component.exports